import React from "react";
import {
  Box,
  Typography,
  Card,
  CardContent,
  IconButton,
  Chip,
  Stack,
} from "@mui/material";
import { CloudUpload, Close } from "@mui/icons-material";

const UploadIdProof = ({ form, handleSingleImageUpload, setField }) => {
  const inputRef = React.useRef();
  return (
    <Box>
      <Typography variant="h6" sx={{ fontWeight: 700, mb: 2 }}>
        Upload ID Proof (Image)
      </Typography>
      <Card
        variant="outlined"
        sx={{ borderStyle: "dashed", mb: 2, cursor: "pointer" }}
        onClick={() => inputRef.current?.click()}
      >
        <CardContent sx={{ textAlign: "center" }}>
          <CloudUpload sx={{ fontSize: 44, mb: 1 }} />
          <Typography>Click to choose an image (JPG/PNG)</Typography>
          <input
            ref={inputRef}
            type="file"
            accept="image/jpeg,image/png"
            style={{ display: "none" }}
            onChange={(e) => handleSingleImageUpload(e, "ID_proof")}
          />
        </CardContent>
      </Card>

      {form.ID_proof && (
        <Stack direction="row" spacing={2} alignItems="center">
          <img
            src={form.ID_proof.url}
            alt={form.ID_proof.name}
            style={{
              width: 140,
              height: 140,
              objectFit: "cover",
              borderRadius: 8,
            }}
          />
          <Stack direction="row" spacing={1} alignItems="center">
            <Chip label={form.ID_proof.name} />
            <IconButton onClick={() => setField("ID_proof", null)}>
              <Close />
            </IconButton>
          </Stack>
        </Stack>
      )}
    </Box>
  );
};

export default UploadIdProof;
